const MORE_OPTION_FIELDS = [
	"dueDate",
	"cycle",
	"estimate",
	"milestone",
	"release",
	"parent",
	"link",
] as const

export type MoreOptionField = (typeof MORE_OPTION_FIELDS)[number]

export function isMoreOptionField(value: string): value is MoreOptionField {
	return (MORE_OPTION_FIELDS as readonly string[]).includes(value)
}

// Linear's order in its own "..." menu, with the team-dependent fields in between.
export function availableMoreOptions({
	cyclesEnabled,
	hasEstimates,
	hasProject,
}: {
	cyclesEnabled: boolean
	hasEstimates: boolean
	hasProject: boolean
}): MoreOptionField[] {
	return [
		"dueDate",
		...(cyclesEnabled ? (["cycle"] as const) : []),
		...(hasEstimates ? (["estimate"] as const) : []),
		...(hasProject ? (["milestone"] as const) : []),
		"link",
		"release",
		"parent",
	]
}

export function linkLabel(link: { url: string; title?: string }) {
	const title = link.title?.trim()
	if (title) return title
	try {
		return new URL(link.url).hostname.replace(/^www\./, "")
	} catch {
		return link.url
	}
}

export function normalizeLinkUrl(raw: string): string | null {
	const trimmed = raw.trim()
	if (!trimmed) return null
	const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
		? trimmed
		: `https://${trimmed}`
	try {
		const url = new URL(withScheme)
		return url.protocol === "http:" || url.protocol === "https:"
			? url.toString()
			: null
	} catch {
		return null
	}
}
